export { default } from './CarrosEletricosBannerSemanaCliente';
